import axios from "../../utils/axios";

export const getLikes = async (id) => {
  const response = await axios.get(`/videos/${id}`);
  const newResponse = await axios.patch(`/videos/${id}`, {
    ...response?.data,
    likes: response?.data?.likes + 1,
  });
  return newResponse?.data;
};
